var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueFormIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1602 10.4385L21.1802 14.6185C20.3402 18.2285 18.6802 19.6885 15.5602 19.3885C15.0602 19.3485 14.5202 19.2585 13.9402 19.1185L12.2602 18.7185C8.09018 17.7285 6.80018 15.6685 7.78018 11.4885L8.76018 7.29854C8.96018 6.44854 9.20018 5.70854 9.50018 5.09854C10.6702 2.67854 12.6602 2.02854 16.0002 2.81854L17.6702 3.20854C21.8602 4.18854 23.1402 6.25854 22.1602 10.4385Z",
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5603 19.3916C14.9403 19.8116 14.1603 20.1616 13.2103 20.4716L11.6303 20.9916C7.66034 22.2716 5.57034 21.2016 4.28034 17.2316L3.00034 13.2816C1.72034 9.31156 2.78034 7.21156 6.75034 5.93156L8.33034 5.41156C8.74034 5.28156 9.13034 5.17156 9.50034 5.10156C9.20034 5.71156 8.96034 6.45156 8.76034 7.30156L7.78034 11.4916C6.80034 15.6716 8.09034 17.7316 12.2603 18.7216L13.9403 19.1216C14.5203 19.2616 15.0603 19.3516 15.5603 19.3916Z",
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1396 8.53125L17.9896 9.76125",
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1602 12.3984L15.0602 13.1384",
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFormIcon);
export default __webpack_public_path__ + "static/media/BlueFormIcon.18e1a8de08a18eb4538d44304130c96e.svg";
export { ForwardRef as ReactComponent };